import { types, applySnapshot } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import * as constants from '../../../common/constants';

const trendsData = types.model('trendsData', {
  identifierId: types.maybeNull(types.string),
  bookId: types.maybeNull(types.string),
  title: types.maybeNull(types.string),
  likeCount: types.maybeNull(types.number),
  disLikeCount: types.maybeNull(types.number),
  explainCount: types.maybeNull(types.number),
  summaryCount: types.maybeNull(types.number),
  quizMcqCount: types.maybeNull(types.number),
  blockWordsCount: types.maybeNull(types.number),
  unknownCount: types.maybeNull(types.number),
  unAnsweredCount: types.maybeNull(types.number),
  unAnsweredNoCSGDocCount: types.maybeNull(types.number),
  unAnsweredUnknownIntentCount: types.maybeNull(types.number),
  unAnsweredNoTopicFoundCount: types.maybeNull(types.number),
  unAnsweredProblemSolveCount: types.maybeNull(types.number),
  historyTitleCount: types.maybeNull(types.number),
  questionIntentCount: types.maybeNull(types.number),
  videoSummaryCount: types.maybeNull(types.number)
});

const trendLineData = types.model('trendLineData', {
  dateStamp: types.maybeNull(types.string),
  identifierId: types.maybeNull(types.string),
  bookId: types.maybeNull(types.string),
  likeCount: types.maybeNull(types.number),
  disLikeCount: types.maybeNull(types.number),
  explainCount: types.maybeNull(types.number),
  summaryCount: types.maybeNull(types.number),
  quizMcqCount: types.maybeNull(types.number),
  blockWordsCount: types.maybeNull(types.number),
  unknownCount: types.maybeNull(types.number),
  unAnsweredCount: types.maybeNull(types.number),
  unAnsweredNoCSGDocCount: types.maybeNull(types.number),
  unAnsweredUnknownIntentCount: types.maybeNull(types.number),
  unAnsweredNoTopicFoundCount: types.maybeNull(types.number),
  unAnsweredProblemSolveCount: types.maybeNull(types.number),
  historyTitleCount: types.maybeNull(types.number),
  questionIntentCount: types.maybeNull(types.number),
  videoSummaryCount: types.maybeNull(types.number)
});

const TrendsCount = types
  .model('Trends', {
    data: types.optional(types.array(trendsData), []),
    showTrendLineData: types.optional(types.array(trendLineData), [])
  })
  .actions((self) => ({
    fetch(payload, tenantId) {
      Framework.getEventManager().publish(constants.GET_TRENDS_COUNT_DATA, {
        payload,
        tenantId
      });
    },
    setResponse(response) {
      applySnapshot(self, response);
    },
    resetStoreValues() {
      applySnapshot(self.data, []);
      applySnapshot(self.showTrendLineData, []);
    }
  }));

export default TrendsCount;
